"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var MAX_VALUE = 1024;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('AdditionalInformationOrderWizard'), (0, recompose_1.withState)('value', 'setValue', ''), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.setValue(this.props.step4.additionalInformation);
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.step4.additionalIsOpen !==
            nextProps.step4.additionalIsOpen ||
            this.props.step4.additionalInformation !==
                nextProps.step4.additionalInformation ||
            this.props.value !== nextProps.value) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var timer = null;
var component = enhance(function (props) { return (React.createElement("div", { className: 'additional-information' },
    React.createElement(sok_ui_1.Accordion, { isOpen: props.step4.additionalIsOpen },
        React.createElement(sok_ui_1.AccordionHeader, { isOpen: props.step4.additionalIsOpen, onClick: props.step4Toggle },
            React.createElement("b", null, (0, translation_1.getLocalization)('userfront/order/step4/additional/header'))),
        React.createElement("div", { className: 'order-confirmation-accordion-content' },
            React.createElement("div", null,
                React.createElement("label", { htmlFor: 'additional-order-information' }, (0, translation_1.getLocalization)('userfront/order/step4/additional/header')),
                React.createElement(sok_ui_1.TextInput, { id: 'additional-order-information', className: 'white', disabled: props.disableWizardFields, type: "textarea", rows: 6, value: props.value, onChange: function (e) {
                        var value = e.target.value;
                        if (value.length > MAX_VALUE) {
                            return;
                        }
                        props.setValue(value);
                        if (timer !== null) {
                            clearTimeout(timer);
                            timer = null;
                        }
                        timer = setTimeout(function () {
                            props.setAdditionalInformation(value);
                        }, 500);
                    } }),
                React.createElement("div", { className: 'counter' },
                    props.value.length,
                    " / ",
                    MAX_VALUE)))))); });
exports.default = component;
